import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
/**
 * Ref diteruskan supaya Dialog dapat memindahkan fokus ke tombol yang benar saat
 * ia terbuka — tanpa itu, pengguna keyboard mendarat entah di mana.
 */
export const Button = forwardRef(function Button({ variant = 'secondary', htmlType = 'button', busy = false, disabled, iconLeft, iconRight, fullWidth, children, className, ...rest }, ref) {
    const classes = [
        'assist-btn',
        `assist-btn--${variant}`,
        fullWidth ? 'assist-btn--block' : '',
        busy ? 'assist-btn--busy' : '',
        className ?? '',
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsxs("button", { ref: ref, type: htmlType, className: classes, disabled: disabled || busy, "aria-busy": busy || undefined, ...rest, children: [iconLeft ? _jsx("span", { className: "assist-btn__icon", children: iconLeft }) : null, _jsx("span", { className: "assist-btn__label", children: children }), iconRight ? _jsx("span", { className: "assist-btn__icon", children: iconRight }) : null] }));
});
//# sourceMappingURL=Button.js.map